module.exports = __webpack_public_path__ + "img/chart3-s.28730994.png";